import React from 'react';
import styles from './AuditionCard.module.css';

/**
 * @component AuditionCardContent
 * @description 공고 제목 + 제작사 세로 배치
 */
function AuditionCardContent({ title, company, castingDirectorName }) {
  const companyLabel = company && castingDirectorName
    ? `${company} / ${castingDirectorName} 담당자`
    : company || '';

  return (
    <div className={styles.cardContent}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.company}>{companyLabel}</p>
    </div>
  );
}

export default AuditionCardContent;
